import { gettext } from '@eventbrite/i18n';

const NOT_AUTHORIZED_ERROR = gettext(
    'You do not have permission to access the resource you requested.',
);
const SUBSCRIPTION_NOT_FOUND = gettext(
    'The profile you requested does not exist.',
);
const STANDARD_SERVER_ERROR = gettext(
    'There was an issue with the server, try again',
);
export const GENERAL_ERROR_SPEC = {
    NOT_AUTHORIZED: () => NOT_AUTHORIZED_ERROR,
    SUBSCRIPTION_NOT_FOUND: () => SUBSCRIPTION_NOT_FOUND,
    USER_HAS_NO_PASSWORD: () => 'USER_HAS_NO_PASSWORD',

    default: () => STANDARD_SERVER_ERROR,
};
